export const ADMIN_BASE_PATH = '/admin';

export const ADMIN_TAB_ROUTES = Object.freeze([
  { key: 'help', path: '/admin/help' },
  { key: 'home', path: '/admin/home' },
  { key: 'users', path: '/admin/users' },
  { key: 'customRoles', path: '/admin/user-roles' },
  { key: 'componentPolicies', path: '/admin/component-policies' },
  { key: 'jobs', path: '/admin/manage-jobs' },
  { key: 'timeComparison', path: '/admin/time-comparison' },
  { key: 'formManager', path: '/admin/form-manager' },
  { key: 'fieldNotify', path: '/admin/field-notifications' },
  { key: 'dropdowns', path: '/admin/dropdowns' },
  { key: 'fieldDescriptions', path: '/admin/field-descriptions' },
  { key: 'infoBubbles', path: '/admin/info-bubbles' },
  { key: 'components', path: '/admin/create-components' },
  { key: 'dynamicTableEditor', path: '/admin/dynamic-table-editor' },
  { key: 'fieldSearch', path: '/admin/field-search' },
  { key: 'apiTest', path: '/admin/api-test' },
  { key: 'signalrTest', path: '/admin/signalr-test' },
  { key: 'globalVariables', path: '/admin/global-variables' },
  { key: 'userPreferences', path: '/admin/user-preferences' },
  { key: 'sharepoint', path: '/admin/sharepoint-documents' },
]);

const normalizePath = (pathname = '') => String(pathname).replace(/\/+$/, '').toLowerCase();
const tabByPath = Object.fromEntries(ADMIN_TAB_ROUTES.map(({ key, path }) => [normalizePath(path), key]));
const pathByTab = Object.fromEntries(ADMIN_TAB_ROUTES.map(({ key, path }) => [key, path]));

export const getAdminTabFromPath = (pathname) => tabByPath[normalizePath(pathname)] || null;
export const getAdminPathForTab = (key) => pathByTab[key] || '/admin/home';
